import React from 'react';

const Footer = () => (
  <div style={{ backgroundColor: '#333', color: 'white', marginTop: '50px', padding: '10px', textAlign: 'center' }}>
    Fuzzy Logic Fighters © 2023
  </div>
);

export default Footer;
